import { useQuery } from '@tanstack/react-query';
import { postSharedBasketPreview } from '@/lib/api';
import { SharedBasketItemInput } from '@/lib/types';

// The basket holds `{category, file_id}` only - ids are the one identity the
// four selection surfaces share, and the only one the server trusts. Names
// therefore have to be asked for, and asking is also the only way to warn the
// user *before* Generate that a file they picked is no longer shareable:
// create 403s the whole basket without naming it.
export const useBasketPreview = (
  items: SharedBasketItemInput[],
  enabled: boolean,
) =>
  useQuery({
    queryKey: [
      'shared-basket-preview',
      items.map((item) => `${item.category}:${item.file_id}`).join(),
    ],
    queryFn: () => postSharedBasketPreview(items),
    enabled: enabled && items.length > 0,
    staleTime: 0,
    retry: false,
  });

export default useBasketPreview;
